import React from "react";
import { Avatar, Card, Rate } from "antd";
import ResponsiveTable from "../../../design-system/ResponsiveTable";
import { itemRender, onShowSizeChange } from "../../../commons/PaginationFunction";
import {
  doctor_thumb_01,
  doctor_thumb_02,
  doctor_thumb_03,
  doctor_thumb_04,
  doctor_thumb_05
} from "../../../commons/PanelImagepath";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const DoctorListDesboard = () => {
  const { t } = useTranslation("dashboard");
  const data = [
    {
      id: 1,
      ClientName: "Dr. Ruby Perrin",
      Speciality: "Dental ",
      Earned: "$3200.00 ",
      Date: "27 Sep 2019",
      time: "03.40 PM",
      image: doctor_thumb_01
    },
    {
      id: 2,
      ClientName: "Dr. Darren Elder",
      Speciality: "Dental ",
      Earned: "$3100.00 ",
      Date: "1 Nov 2019",
      time: "02.59 PM",
      image: doctor_thumb_02
    },
    {
      id: 3,
      ClientName: "Dr. Deborah Angel",
      Speciality: "Cardiology ",
      Earned: "$4000.00",
      Date: "3 Nov 2019",
      time: "09.59 PM",
      image: doctor_thumb_03
    },
    {
      id: 4,
      ClientName: "Dr. Sofia Brient",
      Speciality: "Urology ",
      Earned: "$3200.00 ",
      Date: "16 Jun 2019",
      time: "04.50 PM",
      image: doctor_thumb_04
    },
    {
      id: 5,
      ClientName: "Dr. Marvin Campbell",
      Speciality: "Orthopaedics ",
      Earned: "$3500.00 ",
      Date: "22 Aug 2019",
      time: "01.50 PM",
      image: doctor_thumb_05
    }
  ];
  const columns = [
    {
      title: t("Doctor Name"),
      dataIndex: "ClientName",
      render: (text, record) => (
        <Link to="/admin/profile" className="subadmin-dashboard__person">
          <Avatar size={32} src={record.image} alt="" />
          <span>{text}</span>
        </Link>
      ),
      sorter: (a, b) => a.ClientName.length - b.ClientName.length
    },
    {
      title: t("Speciality"),
      dataIndex: "Speciality",
      sorter: (a, b) => a.Speciality.length - b.Speciality.length
    },

    {
      title: t("Earned"),
      dataIndex: "Earned",
      sorter: (a, b) => a.Earned.length - b.Earned.length
    },
    {
      title: t("Review"),
      dataIndex: "Rating",
      render: () => <Rate disabled defaultValue={4} className="subadmin-dashboard__rate" />,
      sorter: (a, b) => a.Rating.length - b.Rating.length
    }
  ];
  return (
    <Card title={t("Clients List")} className="subadmin-dashboard__card">
      <ResponsiveTable
        pagination={{
          total: data.length,
          showTotal: (total, range) =>
            t("pagination.showTotal", {
              rangeStart: range[0],
              rangeEnd: range[1],
              total
            }),
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
          itemRender: itemRender
        }}
        columns={columns}
        dataSource={data}
        rowKey={record => record.id}
      />
    </Card>
  );
};
export default DoctorListDesboard;
